module.exports = __webpack_public_path__ + "img/book-quill.d9a1029e.gif";